import { styled as a, variants as d, css as e } from "@lokalise/styled";
import { value as o } from "../../utils/theme/index.js";
const n = a.div`
	width: 100%;
	height: ${({ $height: r }) => `${r}px`};
	border-radius: ${({ $height: r }) => `${r}px`};
	background-color: ${o("color.border.disabled")};
	overflow: hidden;
`, i = a.div`
	height: ${({ $height: r }) => r}px;
	width: ${({ $progress: r }) => r}%;

	${d(
  ({ $progress: r }) => {
    switch (!0) {
      case r < 33:
        return "low";
      case r < 66:
        return "medium";
      default:
        return "high";
    }
  },
  {
    low: e`
				background: ${o("color.background.action.danger.default")};
			`,
    medium: e`
				background: ${o("color.border.warning")};
			`,
    high: e`
				background: ${o("color.background.action.primary.default")};
			`
  }
)}
`;
i.displayName = "ActiveProgressBar";
export {
  i as ActiveProgressBar,
  n as Container
};
//# sourceMappingURL=styles.js.map
